const STREAK_STORAGE_KEY = 'topswe_daily_streak';

export const getStreakData = () => {
  const stored = localStorage.getItem(STREAK_STORAGE_KEY);
  if (!stored) {
    return { currentStreak: 0, lastVisit: null };
  }
  return JSON.parse(stored);
};

export const updateDailyStreak = (userId) => {
  if (!userId) return { currentStreak: 0, lastVisit: null };

  const today = new Date().toDateString();
  const streakData = getStreakData();
  
  if (streakData.lastVisit === today) {
    return streakData;
  }
  
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const yesterdayStr = yesterday.toDateString();
  
  let newStreak;
  if (streakData.lastVisit === yesterdayStr) {
    newStreak = streakData.currentStreak + 1;
  } else {
    newStreak = 1;
  }
  
  const newStreakData = {
    currentStreak: newStreak,
    lastVisit: today
  };
  
  localStorage.setItem(STREAK_STORAGE_KEY, JSON.stringify(newStreakData));
  return newStreakData;
};

export const getCurrentStreak = () => {
  const streakData = getStreakData();
  const today = new Date().toDateString();
  
  if (streakData.lastVisit !== today) {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const yesterdayStr = yesterday.toDateString();
    
    if (streakData.lastVisit !== yesterdayStr) {
      return 0;
    }
  }
  
  return streakData.currentStreak;
};